var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.052 17.9415L18.2954 2.97202C17.4162 1.448 15.7777 0.502078 14.0057 0.500003C12.2335 0.497929 10.5943 1.43994 9.70429 2.97209L0.944373 17.947C0.0360305 19.4743 0.015481 21.3882 0.895312 22.949C1.77587 24.5111 3.42467 25.4833 5.21809 25.4979L22.7654 25.4979C24.5775 25.4803 26.2231 24.5111 27.1036 22.9504C27.983 21.3915 27.9633 19.4819 27.052 17.9415ZM3.09769 19.2171L11.8641 4.23113C12.3081 3.46692 13.1223 2.99897 14.0027 3C14.8831 3.00103 15.697 3.47092 16.1336 4.22778L24.8972 19.2091C25.3566 19.9856 25.3664 20.9416 24.9261 21.7221C24.4852 22.5037 23.6609 22.9891 22.7532 22.998L5.22825 22.9979C4.34 22.9906 3.51412 22.5037 3.07314 21.7214C2.63264 20.9399 2.64292 19.9818 3.09769 19.2171ZM14.0005 20.4979C14.6911 20.4979 15.2509 19.9382 15.2509 19.2479C15.2509 18.5575 14.6911 17.9979 14.0005 17.9979C13.3099 17.9979 12.7501 18.5575 12.7501 19.2479C12.7501 19.9382 13.3099 20.4979 14.0005 20.4979ZM15.2546 7.99786H12.7538V16.7479H15.2546V7.99786Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarning);
export default __webpack_public_path__ + "static/media/icon_warning.d86e8528.svg";
export { ForwardRef as ReactComponent };